import { render, staticRenderFns } from "./SlideNav.vue?vue&type=template&id=1a491fdc&scoped=true&"
import script from "./SlideNav.vue?vue&type=script&lang=ts&"
export * from "./SlideNav.vue?vue&type=script&lang=ts&"
import style0 from "./SlideNav.vue?vue&type=style&index=0&id=1a491fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a491fdc",
  null
  
)

export default component.exports